import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * On mobile-sized devices in landscape orientation,
 * shows a fullscreen overlay asking the user to rotate.
 * Only active on the radio chat page (/app).
 * Desktop (≥1024px) is never affected.
 */
export default function LandscapeGuard() {
  const [showOverlay, setShowOverlay] = useState(false);
  let pathname = '/';
  try { pathname = useLocation().pathname; } catch { /* outside router */ }

  useEffect(() => {
    // Only show on radio page
    if (pathname !== '/app') {
      setShowOverlay(false);
      return;
    }

    function check() {
      const h = window.innerHeight;
      const w = window.innerWidth;
      // Only trigger when height is very short AND width is significantly wider (1.5x)
      // This prevents false positives when virtual keyboard reduces viewport height
      const isVeryShort = h < 400;
      const isLandscape = w > h * 1.5;
      setShowOverlay(isVeryShort && isLandscape);
    }

    check();
    window.addEventListener('resize', check);
    window.addEventListener('orientationchange', check);
    return () => {
      window.removeEventListener('resize', check);
      window.removeEventListener('orientationchange', check);
    };
  }, [pathname]);

  if (!showOverlay) return null;

  return (
    <div
      className="fixed inset-0 z-[9999] flex flex-col items-center justify-center gap-4"
      style={{ backgroundColor: '#0a0a0f' }}
    >
      <div className="text-5xl" style={{ animation: 'rotate-phone 2s ease-in-out infinite' }}>
        📱
      </div>
      <p className="text-lg font-bold" style={{ color: '#90EE90' }}>
        세로 모드로 전환해주세요
      </p>
      <p className="text-sm" style={{ color: '#888' }}>
        Please rotate your device to portrait mode
      </p>
    </div>
  );
}
